import React, { useState, useEffect } from 'react';
import { Alert, AlertDescription, AlertTitle } from '../../components/ui/alert';
import QuizrrLogoMobile from '../../../public/Images/QuizrrLogoMobile.png';
import { TestSeriesCard } from './TestSeriesCard';
import axios from 'axios';
import TopHeader from '../../Layout/TopHeader';
import LogoutModal from '../../components/modals/LogoutModal/LogoutModal';
import { AppLayout } from '../../Layout/AppLayout';

export default function NoTestSeries() {
  const [testSeries, setTestSeries] = useState([]);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchTestSeries = async () => {
      const apiUrl = `/api/packs/non-purchased-groups`;
      try {
        const response = await axios.get(apiUrl);
        const nonPurchasedGroups = response?.data?.data;
        setTestSeries(nonPurchasedGroups);
      } catch (error) {
        console.error('Error fetching test series:', error);
        setError('Failed to load test series. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchTestSeries();
  }, []);

  if (loading) {
    return (
      <main className="flex mb-10 justify-center bg-[var(--q3-surface-default)]">
        <div className="text-center p-10">Loading test series...</div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="flex mb-10 justify-center bg-[var(--q3-surface-default)]">
        <div className="text-center p-10 text-red-500">{error}</div>
      </main>
    );
  }

  return (
    <AppLayout>
      <div className="w-full p-5 lg:w-9/12">
        <TopHeader />
        <Alert className="mb-12 bg-[var(--q3-surface-dimmer)] py-8 border-0">
          <AlertTitle className="text-center text-lg font-bold wrap-break-word">
            Looks like you haven't purchased any test series with this email id.
          </AlertTitle>
          <AlertDescription>
            <div className="flex flex-wrap w-full items-center justify-center text-center gap-1">
              <span className="text-[var(--q3-neutral-light)]">
                If your purchased test series isn't visible, you may have used a different email ID.
                <br /> Please{' '}
                <span
                  onClick={() => setShowLogoutModal(true)}
                  className="text-[var(--q3-accent-normal)] underline cursor-pointer"
                >
                  log out
                </span>{' '}
                and sign in with the correct email. <br />
                <br /> If the issue persists, contact us at&nbsp;
                <a
                  href="mailto:support@mathongo.com"
                  className="text-[var(--q3-accent-normal)] font-medium underline cursor-pointer"
                >
                  support@mathongo.com
                </a>
              </span>
            </div>
          </AlertDescription>
        </Alert>

        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <img src={QuizrrLogoMobile} alt="Quizrr Logo" className="h-9 w-auto" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-[var(--q3-neutral-normal)]">
            Explore India&apos;s <span className="text-[var(--q3-accent-normal)] ">Most Relevant</span> Test Series
          </h1>
        </div>

        <div className="grid gap-6 grid-cols-[repeat(auto-fit,minmax(280px,1fr))]">
          {testSeries?.map((series) => (
            <TestSeriesCard key={series._id} series={series} />
          ))}
        </div>
      </div>
      {showLogoutModal && <LogoutModal isOpen={showLogoutModal} onClose={() => setShowLogoutModal(false)} />}
    </AppLayout>
  );
}
